import React from "react";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from "@material-ui/core";


const useStyles = makeStyles(() => ({
  grow: {
    flexGrow: 1
  }
}));

const CustomBottomBar = (props) => {

  const classes = useStyles();

  return (
    <div>
      <AppBar
        position="fixed"

        color="default"
        style={{
          top: "auto",
          bottom: 0,
          paddingLeft: props.isDrawerOpen ? 280 : 0
        }}

      >
        <Toolbar variant="dense">
          <Button
            variant="contained"
            color="default"
            onClick={() => props.leftButtonAction()}
            disabled={props.leftButtonDisable}
            style={{ display: props.leftButtonHide ? "none" : "block", textTransform: "capitalize", ...props.leftButtonStyle }}
          >
            {props.leftButtonText}
          </Button>
          <div className={classes.grow} />
          {props.otherActions}
          <Button
            variant="contained"
            color="primary"
            style={{ display: props.rightButtonHide ? "none" : "block", textTransform: "capitalize", ...props.rightButtonStyle }}
            disabled={props.isLoading || props.rightButtonDisable}
            onClick={() => props.rightButtonAction()}
          >

            {props.isLoading ?
              <CircularProgress
                size={24}
                style={{ color: 'white' }}
              />

              :
              props.rightButtonText
            }
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}

CustomBottomBar.propTypes = {
  rightButtonAction: PropTypes.func,
  rightButtonText: PropTypes.string,
  rightButtonHide: PropTypes.bool,
  rightButtonDisable: PropTypes.bool,
  rightButtonStyle: PropTypes.object,
  leftButtonAction: PropTypes.func,
  leftButtonHide: PropTypes.bool,
  leftButtonText: PropTypes.string,
  leftButtonDisable: PropTypes.bool,
  leftButtonStyle: PropTypes.object,
  isLoading: PropTypes.bool,
  isDrawerOpen: PropTypes.bool,
  otherActions: PropTypes.any

}

CustomBottomBar.defaultProps = {
  rightButtonAction: fn => fn,
  rightButtonText: "Save",
  rightButtonHide: false,
  rightButtonStyle: {},
  leftButtonAction: fn => fn,
  leftButtonHide: false,
  leftButtonText: "View",
  leftButtonStyle: {},
  isLoading: false,
  isDrawerOpen: false,
  rightButtonDisable: false,
  leftButtonDisable: false,
  otherActions: ""

}

export default CustomBottomBar;
